import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5eedd7dd"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "client-space"
}
const _hoisted_2 = { class: "main-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ClientNavbar = _resolveComponent("ClientNavbar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_ClientFooter = _resolveComponent("ClientFooter")!
  const _component_ShowToast = _resolveComponent("ShowToast")!
  const _component_DynamicDialog = _resolveComponent("DynamicDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (this.$store.state.authenticated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_ClientNavbar),
          _createElementVNode("main", _hoisted_2, [
            _createVNode(_component_router_view)
          ]),
          _createVNode(_component_ClientFooter)
        ]))
      : (_openBlock(), _createBlock(_component_router_view, { key: 1 })),
    _createVNode(_component_ShowToast),
    _createVNode(_component_DynamicDialog, { contentStyle: { padding: 0 } })
  ], 64))
}